import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { getDoctorProfile } from "../../api/Doctor";

import * as configuration from "../../config/app-config.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import moment from "moment-timezone";
import { notification } from "antd";
import { requestAppointment } from "../../api/Login.js";
import Loader from "../../customJS/Loader.jsx";
import noDoctorImg from "../../images/noDoctor.png";

const DoctorProfile = () => {
  const [doctorData, setDoctorData] = useState([]);
  const [loader, setLoader] = useState([]);
  // const [notes, setNotes] = useState([]);
  const navigate = useNavigate();

  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    let userId = urlParams.get("userId");
    if (userId) {
      try {
        userId = atob(urlParams.get("userId"));
        let obj = { userId: userId };
        getDoctorData(obj);
      } catch (error) {
        console.log("error", error);
        navigate("/home");
      }
    } else {
      navigate("/home");
    }
  }, []);

  const getDoctorData = (obj) => {
    setLoader(true);
    getDoctorProfile(obj)
      .then((response) => {
        if (response.data.status === 1) {
          setDoctorData(response.data.data);
          setLoader(false);
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoader(false);
      });
  };

  const onButtonClickNavigateWebsite = () => {
    if (doctorData.getDoctorProfile.website) {
      window.open(doctorData.getDoctorProfile.website, "_blank");
    } else {
      api.error({
        message: "No Website Found",
        description: "The doctor does not have a website associated with them.",
        placement: "top", // Correctly specify the placement option
      });
    }
  };

  // const handleappointment = () => {
  //   let obj ={ notes: notes, mailId : doctorData?.getDoctorProfile?.hospitalMailId };
  //   setLoader(true);
  //   requestAppointment(obj)
  //     .then((response) => {
  //       if (response.data.status === 1) {
  //         openNotification();
  //         // setDoctorData(response.data.data);
  //         setLoader(false);
  //       } else {
  //         setLoader(false);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       setLoader(false);
  //     });
  // };

  // const openNotification = () => {
  //   api.success({
  //     message: `Appointment Request Sent`,
  //     description: `Your appointment request has been successfully submitted. We will notify you once the admin reviews and confirms your request.`,
  //     placement: `top`, // Correctly specify the placement option
  //   });

  //   // Clear notes after showing the notification
  //   setNotes("");
  // };

  return (
    <Container className="my-5">
      {contextHolder}
      {loader && <Loader />}
      <Row>
        <Col md={12}>
          <Card className="p-4 border-0">
            <Row>
              <Col md={8}>
                <h4 className="uniteColor">
                  {doctorData?.getDoctorProfile?.displayName}
                </h4>
                <p className="uniteColorBold">
                  {doctorData?.getDoctorProfile?.specialityName}{" "}
                  {doctorData?.getDoctorProfile?.gender && <span className="ball p-2">•</span>}
                  {doctorData?.getDoctorProfile?.gender}
                  {doctorData?.getDoctorProfile?.age &&<span className="ball p-2">•</span>}
                  {doctorData?.getDoctorProfile?.age}
                </p>
                <p className="unitedTextColor">
                  {/* {doctorData?.getDoctorProfile?.bio} */}
                  {doctorData?.getDoctorProfile?.bio
                    .split("\n")
                    .map((line, index, array) => (
                      <span key={index}>
                        {line}
                        {index < array.length - 1 && <br />}
                      </span>
                    ))}
                </p>
                <Row>
                  {doctorData?.locations?.length !== 0 && (
                    <Col xs={6}>
                      <h5 className="uniteColor">Now Practicing At</h5>
                      {doctorData?.locations?.map((location, index) => (
                        <p className="unitedTextColor" key={index}>
                          <span className="uniteColorBold">
                            {location.hospitalName}
                          </span>
                          ,{location.hospitalAddress}
                        </p>
                      ))}

                      {/* <p>263 Farmington Ave Farmington, CT 06032</p> */}
                      {/* <Button variant="primary" className="mb-4">
                      Make an Appointment
                    </Button> */}
                    </Col>
                  )}
                  <Col xs={6}>
                    <h5 className="uniteColor">Contact</h5>
                    <p className="unitedTextColor me-1">
                      <Icon
                        icon="material-symbols:mail-outline"
                        width="24"
                        height="24"
                        className="me-2"
                        style={{ color: "#0D224E" }}
                      />
                      {doctorData?.getDoctorProfile?.mailId ||
                        "Email Id is not available"}
                    </p>
                    <p className="unitedTextColor">
                      <Icon
                        icon="ic:outline-phone"
                        width="24"
                        height="24"
                        className="me-2"
                        style={{ color: "#0D224E" }}
                      />{" "}
                      {doctorData?.getDoctorProfile?.phoneNo ||
                        "Phone number is not available"}
                    </p>
                    {/* <p>
                      Address: 201 E Sample Rd, Pompano Beach, FL 33064, USA
                    </p> */}
                  </Col>
                </Row>
              </Col>
              <Col md={4} className="text-center profile-img-container">
                {/* <span className="profile-img-container"> */}
                {/* {doctorData?.getDoctorProfile?.image ?  */}
                <img
                  src={
                    doctorData?.getDoctorProfile?.image
                      ? `${configuration.API_URL}auth/assets/${doctorData?.getDoctorProfile?.image}`
                      : noDoctorImg
                  }
                  alt={doctorData?.getDoctorProfile?.displayName}
                  className="img-fluid mb-3"
                />
                {/* </span> */}
                {/* <p>
                  <strong>Rating:</strong> 4.6 (36 Ratings)
                </p> */}
              </Col>
            </Row>
            {doctorData?.getDoctorProfile?.overview && <Row>
              <Col>
                <h5 className="uniteColor font-weight-bold m-0">Overview</h5>
                <hr />
                <p className="unitedTextColor">
                  {doctorData?.getDoctorProfile?.overview
                    .split("\n")
                    .map((line, index, array) => (
                      <span key={index}>
                        {line}
                        {index < array.length - 1 && <br />}
                      </span>
                    ))}
                </p>
              </Col>
            </Row>}
            {doctorData?.getDoctorProfile?.experiences &&
              doctorData?.getDoctorProfile?.experiences !== "undefined" && (
                <Row>
                  <Col>
                    <h5 className="uniteColor font-weight-bold m-0">
                      Experience
                    </h5>
                    <hr />
                    <ul className="unitedTextColor">
                      {JSON.parse(
                        doctorData?.getDoctorProfile?.experiences
                      ).map((exp, index) => (
                        <li key={index}>
                          <strong>{exp.experience}</strong> ({" "}
                          {moment(exp.startYear, "YYYY-MM-DD").format("YYYY")} -{" "}
                          {moment(exp.endYear, "YYYY-MM-DD").format("YYYY")} )
                        </li>
                      ))}
                      {/* 
                  <li>
                    <strong>Canadian Health Solution:</strong> 263 Farmington
                    Ave Farmington, CT 06032 (2016 - 2019)
                  </li> */}
                    </ul>
                  </Col>
                </Row>
              )}
            <hr />
            <Row>
              <Col xs="12" md="6">
                <h5 className="uniteColor">Request Appointment</h5>
                {/* <Form>
                  <Form.Group>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Add A Note"
                      value={notes}
                      onChange={(e) => setNotes(e.target.value)}
                    />
                  </Form.Group> */}
                <Button
                  variant="primary"
                  onClick={() => onButtonClickNavigateWebsite()}
                  className="mt-3 uniteButton-lg"
                >
                  Book Appointment
                </Button>
                {/* </Form> */}
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default DoctorProfile;
